import type { Action, SagaIterator, Task } from 'redux-saga';
import type { ActionPattern } from 'redux-saga/effects';
import { takeEvery } from 'typed-redux-saga';
import type { SagaManager } from '../manager';

export function createInjectable({ manager, name, worker }: Params) {
  let counter = 0;
  const registry = new Map<string, Task>();

  function inject(pattern: ActionPattern, id = String(++counter)) {
    const task = manager.run(`${name}:${id}`, function* () {
      yield* takeEvery(pattern, worker);
    });

    registry.set(id, task);

    return () => {
      task.cancel();
      registry.delete(id);
    };
  }

  function disposeAll() {
    registry.forEach((task) => {
      task.cancel();
    });

    registry.clear();
  }

  return { inject, disposeAll };
}

type Params = {
  manager: SagaManager;
  name: string;
  worker: ((action: Action) => SagaIterator) | ((action: Action) => void);
};
